// extracted by mini-css-extract-plugin
export var headerWrapper = "Header-module--headerWrapper--4a215";
export var logoImg = "Header-module--logoImg--21fae";